/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Plan_Feat4Inputs */

const en_builder_plan_feat4 = /** @type {(inputs: Builder_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try on your phone, restore versions, human review from Rp 150k`)
};

const id_builder_plan_feat4 = /** @type {(inputs: Builder_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba di HP, kembalikan versi, tinjauan manusia mulai Rp 150 rb`)
};

/**
* | output |
* | --- |
* | "Try on your phone, restore versions, human review from Rp 150k" |
*
* @param {Builder_Plan_Feat4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const builder_plan_feat4 = /** @type {((inputs?: Builder_Plan_Feat4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Plan_Feat4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builder_plan_feat4(inputs)
	return en_builder_plan_feat4(inputs)
});